export enum Status {
    ENABLE = 1,
    DISABLE = 0,
}